export default "__VITE_ASSET__iXP9uTPw__"